module.exports = Symbol;